import Vue from 'vue';
import VueCookies from "vue-cookies";

Vue.use(VueCookies);

// Params check
const urlSearchParams = new URLSearchParams(window.location.search);
const paramsLang = urlSearchParams.get("lang");

// Cookie check
const cookieLang = VueCookies.get("locale");

// Navigator check
const browserLang = navigator.language.substring(0, 2);

// Get the language choice based on the order of preference using params, cookies, and browser settings
const languageChoice = () => {
  if (paramsLang) {
    return paramsLang;
  } else if (cookieLang) {
    return cookieLang;
  } else if (browserLang === "en" || browserLang === "fr") {
    return browserLang;
  } else {
    return "fr";
  }
};

// Set the global <html> lang attribute to the chosen or default language
document.documentElement.lang = languageChoice();

const defaultState = {
  bannerClosed: false,
  locale: languageChoice(),
  refNumber: ''
};

const mutations = {
  changeLocale(state) {
    if (state.locale === "fr") {
      state.locale = "en";
      VueCookies.set("locale", "en", null, null, ".beneva.ca");
    } else if (state.locale === "en") {
      state.locale = "fr";
      VueCookies.set("locale", "fr", null, null, ".beneva.ca");
    } else {
      state.locale = "fr";
      VueCookies.set("locale", "fr", null, null, ".beneva.ca");
    }
  },
  closeBanner(state) {
    state.bannerClosed = true;
  },
  setInputValue(state, value) {
    state.refNumber = value;
  },
};

const actions = {
  updateInputValue({ commit }, value) {
    commit('setInputValue', value);
  },
}

export default {
  state: defaultState,
  mutations,
  actions
};
